import {createContext} from 'react'

function noop() {
}

export const MenuDesignerContext = createContext({
    values: {},
    onChangeValues: noop,
    menu: [],
    selectItem: noop,
    selectedItem: {},
    onChangeMenuItemProps: noop
});
